import { Button } from "reactstrap";
import { FormattedMessage } from "react-intl";
import React, { useCallback } from "react";
import { useLocalizedAppContext } from "src/app/hooks/useLocalizedAppContext";
import { useAuthenticateOtpResend } from "src/authentication/hooks/useAuthenticateOtp";
import type { AuthenticationOTPContext } from "src/authentication/objects/Authentication";
import { LoadingSpinner } from "src/shared/components/Loading";

export interface IResendOTPButtonProps {
  authenticationOtpContext: AuthenticationOTPContext;
  onContextReset: (authenticationOtpContext: AuthenticationOTPContext) => void;
}

export const ResendOTPMessage = ({
  authenticationOtpContext,
  onContextReset,
}: IResendOTPButtonProps) => {
  const { languageCode } = useLocalizedAppContext();

  const { mutateAsync: resendOtp, isLoading } = useAuthenticateOtpResend();

  const handleResendOtp = useCallback(async () => {
    const { username, authenticationToken } = authenticationOtpContext;
    const { nonce, mobileNumber } = await resendOtp({
      username,
      authenticationToken,
      languageCode,
    });
    onContextReset({
      username,
      authenticationToken,
      nonce,
      mobileNumber,
    });
  }, [authenticationOtpContext, languageCode, onContextReset, resendOtp]);

  return (
    <FormattedMessage
      id="authentication.otp.invalid"
      values={{
        retryLink: (
          <Button
            type="button"
            color="link"
            onClick={handleResendOtp}
            disabled={isLoading}
          >
            <FormattedMessage id="authentication.otp.invalid.resendCode" />
            {isLoading && (
              <>
                {" "}
                <LoadingSpinner />
              </>
            )}
          </Button>
        ),
      }}
    />
  );
};
